import { useEffect } from "react";
import { useAppIconSlots, getSlotUrl } from "@/hooks/useAppIconSlots";

const VITOLIER_THEME_COLOR = "#794939";
const VITOLIER_BG_COLOR = "#794939";

/**
 * Dynamically generates and injects a web app manifest based on
 * QA-approved app icon slots from the database.
 * Falls back to the static /manifest.json icons when no slots are populated.
 */
export function DynamicManifest() {
  const { data: slots } = useAppIconSlots();

  useEffect(() => {
    if (!slots) return;

    const url512 = getSlotUrl(slots, "app-512");
    const url192 = getSlotUrl(slots, "app-192");

    // Only override manifest if at least one icon is set
    if (!url512 && !url192) return;

    const icons: Array<{ src: string; sizes: string; type: string; purpose?: string }> = [];

    if (url192) {
      icons.push({ src: url192, sizes: "192x192", type: "image/png" });
    }
    if (url512) {
      icons.push({ src: url512, sizes: "512x512", type: "image/png" });
      icons.push({ src: url512, sizes: "512x512", type: "image/png", purpose: "maskable" });
    }

    const manifest = {
      name: "Vitolier",
      short_name: "Vitolier",
      description: "The Global Registry of Premium Cigars",
      start_url: "/",
      scope: "/",
      display: "standalone",
      orientation: "portrait-primary",
      background_color: VITOLIER_BG_COLOR,
      theme_color: VITOLIER_THEME_COLOR,
      icons,
    };

    const blob = new Blob([JSON.stringify(manifest)], { type: "application/json" });
    const blobUrl = URL.createObjectURL(blob);

    let link = document.head.querySelector('link[rel="manifest"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "manifest");
      document.head.appendChild(link);
    }
    const oldHref = link.getAttribute("href");
    link.setAttribute("href", blobUrl);

    return () => {
      URL.revokeObjectURL(blobUrl);
      if (link && oldHref) link.setAttribute("href", oldHref);
    };
  }, [slots]);

  return null;
}
